import React from "react";
import { Award } from "lucide-react";

const clients = [
  { name: "Global CPG Enterprise", industry: "CPG" },
  { name: "US Financial Services Firm", industry: "Financial Services" },
  { name: "Fortune 500 Technology", industry: "Technology" },
  { name: "National Retail Chain", industry: "Retail" },
  { name: "Global Insurance Group", industry: "Insurance" },
  { name: "Manufacturing Leader", industry: "Manufacturing" },
];

const ClientLogosStrip = () => {
  return (
    <section className="py-12 bg-white border-y border-slate-200">
      <div className="container-x">
        <div className="flex flex-col md:flex-row md:items-center gap-6 md:gap-10">
          <div className="md:w-64 shrink-0">
            <div className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-[#1E56E3]">
              <Award size={14} /> Trusted by
            </div>
            <div className="mt-2 text-lg font-bold text-[#0B1B3B] leading-tight">Enterprise data teams across industries</div>
          </div>

          <div className="flex-1 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
            {clients.map((c) => (
              <div key={c.name} className="reveal group rounded-xl border border-slate-200 bg-white px-4 py-4 flex flex-col items-center justify-center text-center hover:border-[#1E56E3]/40 transition-colors">
                <div className="h-10 w-10 rounded-lg bg-[#0B1B3B] text-white flex items-center justify-center text-[11px] font-extrabold">
                  {c.industry.split(" ").map((w) => w[0]).slice(0, 2).join("")}
                </div>
                <div className="mt-2 text-[10px] font-bold uppercase tracking-wider text-[#1E56E3]">{c.industry}</div>
                <div className="text-[11px] text-slate-500 leading-tight line-clamp-2 mt-0.5">{c.name}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientLogosStrip;
